import Icons from 'assets/icons'
import { useRequest } from 'hooks/useRequest';
import useToast from 'hooks/useToast';
import {useDispatch, useSelector} from 'react-redux';
import {updateEdittedRow} from 'redux/features/projectDetail/projectDetailSlice';

const FileUploadEditor = ({ options, addEndpoint, deleteEndpoint, idName }) => {
	const [uploadFile] = useRequest()
	const [deleteFile] = useRequest()
	const {showToast} = useToast()
	const { edittedRow } = useSelector((state) => state.projectDetail)
	const dispatch = useDispatch()
	const validateSelectedFile = (file) => {
        const MAX_FILE_SIZE = 20480 // 20MB
        const fileSizeKiloBytes = file.size / 1024
        let errorMsg = ''
        if(fileSizeKiloBytes > MAX_FILE_SIZE){
          errorMsg = "Dosya 20mb'dan küçük olmalıdır ";
        }
        return errorMsg
      };
	const convert = async (fileList) => {
		let errorMessage = ''
		for (let i = 0; i < fileList.length; i++) {
			const file = fileList[i];
			if (validateSelectedFile(file) != '') {
				errorMessage = validateSelectedFile(file)
				break
			}
		}
		if (errorMessage == '') {
			for await (const file of fileList) {
				const formData = new FormData();
				formData.append("File", file);
				formData.append(idName, edittedRow.id)
				uploadFile(addEndpoint, {
					method: 'POST',
					data: formData
				}).then(res => {
					if (res.data.ok) {
						dispatch(updateEdittedRow({key:options.field,value:[...edittedRow[options.field],{...res.data.result}]}))
					}else {
						showToast(res.data.metadata.message,'error')
					}
				})
			}
		}else {
			showToast(errorMessage,'error')
		}
	};
	const handleDelete = async (deleteData, index) => {
		deleteFile(deleteEndpoint, {
			method: 'DELETE',
			data: deleteData
		}).then(res => {
			if (res.data.ok) {
				dispatch(updateEdittedRow({key:options.field,value:[...edittedRow[options.field].filter((f,i) => i != index)]}))
			}
		})
	}
	return (
		<div className='form-control'>
			<label htmlFor='file' className='text-primary text-underlined cursor-pointer'>
				Dosya Ekle
			</label>
			<span className='d-flex flex-wrap gap-2'>
				{edittedRow[options.field]?.length > 0 &&
					edittedRow[options.field].map((value, index) => (
						<span key={index} className='border-font'>
							<span className='word-break'>{value.fileName}</span> <Icons.close onClick={() => handleDelete(value, index)} className='cursor-pointer' />
						</span>
					))}
			</span>
			<input type='file' multiple className='d-none' id='file' onChange={(e) => convert(e.target.files)} />
		</div>
	)
}

export default FileUploadEditor
